// extracted by mini-css-extract-plugin
export default {"root":"PdfViewer__root--vv0ry","mobile":"PdfViewer__mobile--L8-6E","buffer":"PdfViewer__buffer--32ilA","bufferPage":"PdfViewer__bufferPage--32GCf"};